import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import TranscriptView from "./pages/TranscriptView";
import SharedTranscript from "./pages/SharedTranscript";
import Pricing from "./pages/Pricing";
import PaymentReturn from "./pages/PaymentReturn";
import Generate from "./pages/Generate";
import Voices from "./pages/Voices";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/payment-return" element={<PaymentReturn />} />
                        <Route path="/app" element={<Dashboard />} />
                        <Route path="/app/t/:id" element={<TranscriptView />} />
                        <Route path="/generate" element={<Generate />} />
                        <Route path="/voices" element={<Voices />} />
                        <Route path="/share/:id" element={<SharedTranscript />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </AuthProvider>
        </div>
    );
}

export default App;
